export enum DocumentTypeEnum {
    CEDULA_CIUDADANIA = 'CC',
    PASAPORTE = 'PAS',
    NIT = 'NIT'
}
